"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFilesButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_dropzone_1 = require("react-dropzone");
var Button_1 = require("../../atoms/Button");
var Icon_1 = require("../../atoms/Icon");
var icons_1 = require("../../icons");
var styles_1 = __importDefault(require("./styles"));
var utils_1 = require("../../utils");
var UploadFilesButton = function (_a) {
    var handler = _a.handler, _b = _a.isPlusIconButton, isPlusIconButton = _b === void 0 ? false : _b, _c = _a.maxFileSize, maxFileSize = _c === void 0 ? 100 : _c, // MB size
    _d = _a.acceptedFileTypes, // MB size
    acceptedFileTypes = _d === void 0 ? 'image/jpg,image/jpeg,image/png,video/mp4' : _d, _e = _a.multiple, multiple = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.title, title = _g === void 0 ? 'UPLOAD' : _g, buttonProps = _a.buttonProps, additionalValidators = _a.additionalValidators;
    var validator = (0, react_1.useCallback)(function (file) {
        var maxSize = 1048576 * maxFileSize;
        try {
            if ((0, utils_1.isUnsupportedFile)(file)) {
                return {
                    code: "file-unsupported",
                    message: "File is not of supported type"
                };
            }
            if (file.size > maxSize) {
                return {
                    code: "file-too-large",
                    message: "File is larger than ".concat(maxFileSize, "MB")
                };
            }
            return additionalValidators ? additionalValidators(file) : null;
        }
        catch (err) {
            console.error(err);
        }
        return null;
    }, [additionalValidators, maxFileSize]);
    var onDrop = react_1.default.useCallback(function (acceptedFiles) {
        if (acceptedFiles) {
            var fileList = Array.from(acceptedFiles).map(function (file) { return ({ file: file }); });
            handler(fileList);
        }
    }, [handler]);
    var handleChange = function (e) {
        var files = e.target.files;
        onDrop(files);
    };
    var _h = (0, react_dropzone_1.useDropzone)({
        accept: acceptedFileTypes,
        onDrop: onDrop,
        validator: validator,
    }), getRootProps = _h.getRootProps, getInputProps = _h.getInputProps, fileRejections = _h.fileRejections;
    var classes = (0, styles_1.default)({
        isPlusIconButton: isPlusIconButton,
        isError: fileRejections.length > 0
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Button_1.Button, __assign({ role: "button", variant: "outlined", component: "label" }, getRootProps(), { id: "upload-button", className: classes.button, disabled: disabled, color: fileRejections.length ? 'error' : undefined }, buttonProps, { children: [isPlusIconButton && ((0, jsx_runtime_1.jsx)(core_1.Box, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ height: "60", width: "60", simple: true, viewBox: "0 0 64 64" }, { children: (0, jsx_runtime_1.jsx)(icons_1.Plus, {}) })) })), title] })), !multiple && (0, jsx_runtime_1.jsx)("p", __assign({ className: classes.errorText }, { children: fileRejections.length > 0 && fileRejections[0].errors[0].message })), (0, jsx_runtime_1.jsx)("input", __assign({ id: "upload-input", accept: acceptedFileTypes, type: "file", onChange: handleChange }, getInputProps(), { multiple: multiple, 
                // invisible means that it is not accessible, so "hide" another way
                style: { opacity: 0, zIndex: -1, position: 'absolute' } }))] }));
};
exports.UploadFilesButton = UploadFilesButton;
